import {
  enterAssayResultsActionType,
  enterAssayResultsSuccessActionType,
  enterAssayResultsFailureActionType,
} from 'actions/Lots/enterAssayResults';

const INITIAL_STATE = {
  isPending: false,
};

const enterAssayResultsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case enterAssayResultsActionType:
      return {
        isPending: true,
      };
    case enterAssayResultsSuccessActionType:
    case enterAssayResultsFailureActionType:
      return {
        isPending: false,
      };
    default:
      return state;
  }
};

export { enterAssayResultsReducer };
